<template>
    <div>
        <span class="u-text" @click="onCode" :style="styleCode">{{ startText }}</span>
    </div>
</template>

<script>
    export default {
        name: 'CaptchaFetch',
        data() {
            return {
                startText: this.$t('获取验证码'),
                secNum: 60,
                changeText: this.$t('X秒重新获取'),
                canGetCode: true, // 是否可以执行验证码操作
                endText: this.$t('重新获取'),
                timer: null,
                styleCode: {
                    color: '#000'
                }
            }
        },
        methods: {
            onCode() {
                if (this.canGetCode) {
                    //写获取验证码接口
                    this.$emit('onCode')
                    this.styleCode.color = '#999'
                    // this.start()
                } else {
                    this.$message({
                        message: this.$t('倒计时结束后再发送'),
                        type: 'warning'
                    });
                }
            },
            // 开始倒计时
            start() {
                // 防止快速点击获取验证码的按钮而导致内部产生多个定时器导致混乱
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                // this.$emit('start');
                this.canGetCode = false;
                // 这里放这句，是为了一开始时就提示，否则要等setInterval的1秒后才会有提示
                this.changeEvent(this.changeText.replace(/x|X/, this.secNum));
                // this.setTimeToStorage();
                this.timer = setInterval(() => {
                    // console.log(this.secNum);
                    if (--this.secNum) {
                        // 用当前倒计时的秒数替换提示字符串中的"x"字母
                        this.changeEvent(this.changeText.replace(/x|X/, this.secNum));
                        this.styleCode.color = '#999'
                    } else {
                        clearInterval(this.timer);
                        this.timer = null;
                        this.changeEvent(this.endText);
                        this.styleCode.color = '#61AC85'
                        this.secNum = 60;
                        this.$emit('end');
                        this.canGetCode = true;
                    }
                }, 1000);
            },
            changeEvent(text) {
                // console.log(text);
                this.startText = text
                // this.$emit('change', text);
            },
        },
    };
</script>

<style>
    .u-text {
        color: #000;
        cursor: pointer;
        font-size: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/CaptchaFetch.vue